var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46754 0.531875L1.02504 3.97437C0.732539 4.26687 0.732539 4.73937 1.02504 5.03187C1.31754 5.32437 1.79004 5.32437 2.08254 5.03187L5.00004 2.12187L7.91004 5.03187C8.20254 5.32437 8.67504 5.32437 8.96754 5.03187C9.26004 4.73937 9.26004 4.26687 8.96754 3.97437L5.52504 0.531875C5.24004 0.239375 4.76004 0.239375 4.46754 0.531875Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger_icon.1e0559927b951df8343be3d398443436.svg";
export { ForwardRef as ReactComponent };